import { Link } from 'react-router-dom';
import IMAGES from '../images';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__grid">
          {/* Brand */}
          <div className="footer__brand">
            <img
              src={IMAGES.logoBlanc}
              alt="Khansa Yazidi"
              className="footer__logo"
              onError={(e) => (e.target.style.display = 'none')}
            />
            <p className="footer__brand-text">
              Marque artisanale tunisienne de robinetterie et d'accessoires de salle de bain.
              Laiton massif, marbre, céramique — entièrement façonnés à la main.
            </p>
            <div className="footer__socials">
              <a href="https://instagram.com/yazidikhansa/" target="_blank" rel="noreferrer" className="footer__social-btn">
                Instagram
              </a>
              <a href="https://facebook.com/yazidikhansa/" target="_blank" rel="noreferrer" className="footer__social-btn">
                Facebook
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div className="footer__col">
            <h5 className="footer__col-title">Navigation</h5>
            <Link to="/robinetterie" className="footer__link">Robinetterie</Link>
            <Link to="/vasques" className="footer__link">Vasques</Link>
            <Link to="/accessoires" className="footer__link">Accessoires</Link>
            <Link to="/creations" className="footer__link">Nos Créations Chez Vous</Link>
            <Link to="/garantie" className="footer__link">Garantie</Link>
            <Link to="/produit-entretien" className="footer__link">Produits d'Entretien</Link>
            <Link to="/presse" className="footer__link">Presse</Link>
            <Link to="/contact" className="footer__link">Contact</Link>
          </div>

          {/* Contact */}
          <div className="footer__col">
            <h5 className="footer__col-title">Contactez-Nous</h5>
            <a href="mailto:yazidi.khansa@gmail.com" className="footer__link">
              yazidi.khansa@gmail.com
            </a>
            <a href="tel:+21652428501" className="footer__link">+216 52 428 501</a>

            <h5 className="footer__col-title" style={{ marginTop: '2rem' }}>Showroom</h5>
            <a
              href="https://www.google.com/maps/search/87+av+habib+bourguiba+ez-zahra"
              target="_blank"
              rel="noreferrer"
              className="footer__link"
            >
              87 Av. Habib Bourguiba<br />Ez-Zahra 2034, Tunisie
            </a>

            <h5 className="footer__col-title" style={{ marginTop: '2rem' }}>Horaires</h5>
            <p className="footer__text">Lun – Sam : Sur Rendez-vous</p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer__bottom">
          <p>© {new Date().getFullYear()} Khansa Yazidi — Tous droits réservés</p>
          <p>Artisanat Tunisien · Fait Main · Depuis 2017</p>
        </div>
      </div>
    </footer>
  );
}
